// Visit confirmation beacons (Direkt cleanup plan 2026-09-27, Phase 2) — first-party,
// through the site's /api/asosevent proxy route. visit_js: JavaScript ran (mount + 1 s)
// visit_interact: the first scroll / wheel / pointer / touch / key. They only stamp the
// session (the API writes no statistics row for them); the nightly cron counts a session
// as a visit only when JavaScript ran — what tells a human from a crawler that fetches
// pages without running them. Each beacon fires once per page load (StrictMode re-mounts
// re-arm the listeners but never re-send); the prerender pass is skipped.
import apiClient from '../api/client'

type VisitBeacon = 'visit_js' | 'visit_interact'

const sent = new Set<VisitBeacon>()
const INTERACTIONS = ['scroll', 'wheel', 'pointerdown', 'touchstart', 'keydown'] as const

function send(event: VisitBeacon): void {
	if (sent.has(event)) return
	sent.add(event)
	apiClient.get('/asosevent', { params: { event } }).catch(() => {})
}

/** Arm both beacons; returns the cleanup for the calling effect. */
export function startVisitBeacons(): () => void {
	if (typeof window === 'undefined' || (typeof navigator !== 'undefined' && navigator.webdriver)) {
		return () => {}
	}
	const timer = window.setTimeout(() => send('visit_js'), 1000)
	const onFirst = () => {
		INTERACTIONS.forEach((e) => window.removeEventListener(e, onFirst, true))
		send('visit_interact')
	}
	INTERACTIONS.forEach((e) => window.addEventListener(e, onFirst, { capture: true, passive: true }))
	return () => {
		window.clearTimeout(timer)
		INTERACTIONS.forEach((e) => window.removeEventListener(e, onFirst, true))
	}
}
